import React, { useState, useContext, memo, useEffect } from "react";
import { GoogleMap } from "@react-google-maps/api";
import { FindAStoreContext } from "../contexts/findAStore";
import Markers from "./markers";
import PlaceholderMap from "./map-placeholder";

let handler: ReturnType<typeof setTimeout>;

const options: google.maps.MapOptions = {
  disableDefaultUI: true,
  fullscreenControl: true,
  zoomControl: true,
  styles: [
    {
      featureType: "poi",
      elementType: "labels.text",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "poi.business",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "transit",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
  ],
};

const Maps = () => {
  const [map, setMap] = useState<google.maps.Map>();

  const {
    state: { mapZoom, mapCenter, activeStore },
    dispatch,
  } = useContext(FindAStoreContext);

  const setMapBounds = (payload: {
    zoom?: number;
    center?: google.maps.LatLng;
    bounds?: google.maps.LatLngBounds;
  }) => dispatch({ type: "SetMapBounds", payload });

  const google =
    typeof window !== "undefined" ? window.google : (null as never);

  const updateLocation = () => {
    if (map) {
      setMapBounds({
        zoom: map.getZoom(),
        bounds: map.getBounds() || undefined,
        center: map.getCenter(),
      });
    }
  };

  const debounce = () => {
    if (map) {
      clearTimeout(handler);
      handler = setTimeout(() => {
        updateLocation();
      }, 500);
    }
  };
  useEffect(() => {
    if (map) debounce();
  }, [map]);
  return (
    <div
      sx={{
        "& > div": {
          position: "initial !important" as "initial",
        },
      }}
    >
      <GoogleMap
        center={mapCenter}
        zoom={mapZoom}
        options={options}
        onLoad={setMap}
        onZoomChanged={debounce}
        onDragEnd={updateLocation}
      >
        <Markers />
      </GoogleMap>
    </div>
  );
};

//Maps.whyDidYouRender = true

const MapWrapper: React.FC<{ hideMap?: boolean }> = ({ hideMap }) => {
  const {
    state: { map },
    dispatch,
  } = useContext(FindAStoreContext);
  useEffect(() => {
    if (!map && !hideMap) {
      dispatch({ type: "SetMap", payload: { map: <Maps /> } });
    }
  }, []);
  return map ? map : <PlaceholderMap />;
};

export default MapWrapper;
